import type { ReceiptTemplate } from '../schema';

export const appleTemplate: ReceiptTemplate = {
  id: 'apple',
  name: 'Apple Store Receipt',
  brand: 'Apple',
  description: 'Modern tech retail receipt template inspired by Apple Store',
  settings: {
    width: 300,
    font: 'Arial',
    fontSize: 11,
    paperStyle: 'plain',
    backgroundColor: '#ffffff',
    textColor: '#1d1d1f',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
  },
  sections: [
    {
      id: 'apple-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/apple.png',
        logoData: '',
        logoWidth: 60,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'Apple Fifth Avenue',
          '767 Fifth Avenue',
          'New York, NY 10153',
          '(212) 336-1440',
        ],
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'apple-divider-1',
      type: 'divider',
      enabled: true,
      config: {
        style: 'solid',
        spacing: 12,
      },
    },
    {
      id: 'apple-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'apple-order', label: 'Order #', value: 'W1029384756' },
          { id: 'apple-date', label: 'Date', value: 'September 30, 2025' },
          { id: 'apple-time', label: 'Time', value: '3:22 PM' },
          { id: 'apple-specialist', label: 'Specialist', value: 'Alex T.' },
        ],
        column2: [],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'apple-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        quantityPosition: 'left',
        showHeader: false,
        showHeaderDivider: false,
        headerLabels: {
          quantity: 'Qty',
          item: 'Item',
          amount: 'Price',
        },
        items: [
          { id: 'apple-item-1', quantity: '1', name: 'iPhone 16 Pro Max 256GB', price: '$1,199.00' },
          { id: 'apple-item-2', quantity: '1', name: 'AppleCare+ for iPhone', price: '$199.00' },
          { id: 'apple-item-3', quantity: '1', name: 'MagSafe Charger', price: '$39.00' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'apple-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 50,
        lines: [
          { id: 'apple-subtotal', label: 'Subtotal', value: '1437.00', isBold: false, isLarge: false },
          { id: 'apple-tax', label: 'Tax', value: '127.53', isBold: false, isLarge: false },
          { id: 'apple-total', label: 'Total', value: '1564.53', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'apple-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'apple-method', label: 'Apple Pay', value: 'Visa ****4532' },
          { id: 'apple-status', label: 'Status', value: 'Approved' },
        ],
        cashFields: [
          { id: 'apple-cash', label: 'Cash', value: '$1600.00' },
          { id: 'apple-change', label: 'Change', value: '$35.47' },
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'apple-message',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Returns and exchanges within 14 days.\nVisit apple.com/shop/help/returns_refund\n\nThank you for shopping at Apple.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'apple-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'W1029384756',
        showValue: false,
        width: 1.2,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
  ],
};

